module.exports = __webpack_public_path__ + "/bundle/asset/about-4d20e6c24faf73184034afac788d409b.png";